import { ChangeEvent, FC, useState } from 'react';
// i18next
import { Trans, useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { cloneMedia } from 'store/media/mediaAsync';
import { selectOwners } from 'store/user/userSelectors';
import { selectCkeckedMediaIds } from 'store/media/mediaSelectors';
// Layouts
import { Dialog, DialogTitle, DialogContent, DialogActions } from 'layouts/Dialog';
// Components
import { Button } from 'components/Buttons';
import { Checkbox } from 'components/Controls';

type Props = {
  open: boolean;
  onClose: () => void;
}

const CloneMediaDialog:FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const owners = useAppSelector(selectOwners);
  const ckeckedMediaIds = useAppSelector(selectCkeckedMediaIds);

  const [selectedOwnersIds, setSelectedOwnersIds] = useState<string[]>([]);

  const onChange = (event:ChangeEvent<HTMLInputElement>) => {
    const { name:ownerId } = event.target;
    if (selectedOwnersIds.includes(ownerId)) {
      setSelectedOwnersIds(selectedOwnersIds.filter(id => id !== ownerId));
    } else {
      setSelectedOwnersIds([...selectedOwnersIds, ownerId]);
    }
  }

  const onSubmit = () => {
    dispatch(cloneMedia({ mediaIds: ckeckedMediaIds, ownerIds: selectedOwnersIds })).unwrap()
      .then(() => onClose());
  }
  
  return (
    <Dialog size="lg" open={open} onClose={onClose}>
      <DialogTitle title={t('dialogs.cloneMedia.title')} onClose={onClose} />
      <DialogContent>
        <p className="text-white mb-4">
          <Trans
            i18nKey="dialogs.cloneMedia.hint"
            values={{ mediaLength: ckeckedMediaIds.length }}
          />
        </p>
        {owners?.map(owner => (
          <Checkbox
            key={owner._id}
            id={owner._id} name={owner._id}
            label={`${owner.name} ${owner.surname} (${owner.account.organization})`}
            checked={selectedOwnersIds.includes(owner._id)}
            onChange={onChange} />
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
        >{t('buttons.cancel')}</Button>
        <Button
          className="ml-2"
          variant="contained"
          onClick={onSubmit}
          disabled={!selectedOwnersIds.length}
        >{t('buttons.clone')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default CloneMediaDialog;
